<template>
    <div class="pra-header m-b-15">
        <div class="pull-right">
            <span class="text-muted m-r-10">
                <i v-if="saveState === 'saving'" class="fa fa-spinner fa-spin"></i>
                <i v-else-if="saveState === 'error'" class="fa fa-exclamation-triangle text-danger"></i>
                <i v-else-if="saveState === 'saved'" class="fa fa-check text-success"></i>
                {{ saveText }}
            </span>
            <button type="button" class="btn btn-info btn-sm btn-outline" @click="$emit('recalculate')">
                {{ $t("amas:analysis:pra:recalculate") }}
            </button>
        </div>
        <p class="text-muted m-b-0 m-t-5">
            {{ computedText }} · {{ $t("amas:analysis:pra:sources") }} · {{ manualText }}
        </p>
    </div>
</template>

<script>
export default {
    props: {
        result: { type: Object, required: true },
        saveState: { type: String, default: "idle" },
        savedAt: { type: Date, default: null },
        manualStepCount: { type: Number, default: 0 },
        lastUpdated: { type: String, default: null },
        // The verdicts are derived from the parcel edits rather than set on the cards.
        verdictsFollowEdits: { type: Boolean, default: false },
        // Edits on a result stored before the borders between parcels were recorded.
        verdictsNeedRecalculation: { type: Boolean, default: false },
    },
    methods: {
        formatDateTime(date) {
            return date.toLocaleDateString("sl-SI") + " ob " + date.toLocaleTimeString("sl-SI", { hour: "2-digit", minute: "2-digit" });
        },
    },
    computed: {
        computedText() {
            // Results stored before computed_at existed only carry the date of the last save.
            let text = "-";
            if (this.result.computed_at) {
                text = this.formatDateTime(new Date(this.result.computed_at));
            } else if (this.lastUpdated) {
                text = new Date(this.lastUpdated).toLocaleDateString("sl-SI");
            }
            return this.$t("amas:analysis:pra:computed_at:{}").replace("{}", text);
        },
        verdictOverridden() {
            const r = this.result;
            return (r.model_has_access !== undefined && r.model_has_access !== r.has_access)
                || (r.model_has_physical_access !== undefined && r.model_has_physical_access !== r.has_physical_access);
        },
        manualText() {
            const parts = [];
            if (this.manualStepCount) { parts.push(this.$t("amas:analysis:pra:manual_parcels:{}").replace("{}", this.manualStepCount)); }
            if (this.verdictOverridden) { parts.push(this.$t("amas:analysis:pra:manual_verdict")); }
            if (!parts.length) { return this.$t("amas:analysis:pra:no_manual_changes"); }
            const text = this.$t("amas:analysis:pra:manual_changes:{}").replace("{}", parts.join(", "));
            if (this.verdictsNeedRecalculation) { return text + " - " + this.$t("amas:analysis:pra:verdicts_need_recalculation"); }
            return this.verdictsFollowEdits ? text + " - " + this.$t("amas:analysis:pra:verdicts_follow_edits") : text;
        },
        saveText() {
            if (this.saveState === "saving") { return this.$t("amas:analysis:pra:saving"); }
            if (this.saveState === "error") { return this.$t("amas:analysis:pra:save_failed"); }
            if (this.saveState === "saved" && this.savedAt) {
                return this.$t("amas:analysis:pra:saved_at:{}").replace("{}", this.savedAt.toLocaleTimeString("sl-SI", { hour: "2-digit", minute: "2-digit" }));
            }
            return "";
        },
    },
}
</script>
